import React, { useState } from "react";
import "./QuizForm.css"; // ✅ Import the CSS

function QuizForm({ onStart }) {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        course: "Door Supervisor",
        attempt: 1,
    });

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        onStart(formData);
    };

    return (
        <div className="quiz-form-container">
            <form className="quiz-form" onSubmit={handleSubmit}>
                <h2>Door Supervisor Quiz</h2>
                <p>Please fill in your details to begin the quiz.</p>

                <input
                    name="firstName"
                    placeholder="First Name"
                    required
                    onChange={handleChange}
                />
                <input
                    name="lastName"
                    placeholder="Last Name"
                    required
                    onChange={handleChange}
                />
                <input
                    name="attempt"
                    type="number"
                    min="1"
                    value={formData.attempt}
                    onChange={handleChange}
                    placeholder="Attempt Number"
                />

                <button type="submit">Start Quiz</button>
            </form>
        </div>
    );
}

export default QuizForm;
